var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSudokuGameImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_5868)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 24,
    fill: "url(#paint0_linear_206_5868)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.141 60.9497C158.981 39.3658 130.943 35.8348 121.89 17.002C113.906 0.39495 122.969 -23.6633 113.18 -38.8167C103.517 -53.7738 86.4694 -61.336 70.7079 -62.2203C55.3142 -63.0841 41.6367 -51.6808 27.7733 -43.6089C16.1578 -36.8459 7.50236 -24.9166 -4.27289 -18.5634C-20.1038 -10.022 -43.5689 -17.1322 -53.2802 0.122745C-62.4713 16.4531 -48.2661 38.3823 -47.3952 58.0552C-46.5843 76.3753 -56.2805 96.7332 -48.3106 112.392C-40.1523 128.421 -19.9245 127.063 -6.93467 137.551C4.68477 146.932 11.3289 163.524 23.9728 170.755C37.6539 178.578 53.7286 186.128 68.1366 180.48C82.6798 174.779 88.2638 153.701 99.4424 141.173C109.583 129.808 121.771 122.06 131.181 109.824C142.757 94.7721 163.176 81.2788 161.141 60.9497Z",
    fill: "#B570FA",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1624,
    y: 30.9595,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#B366FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4659 40.439C34.7563 40.439 34.1072 40.2938 33.5185 40.0036C33.2891 39.8905 33.19 39.6239 33.2598 39.3779C33.3632 39.0132 33.7863 38.8465 34.1391 38.9851C34.2446 39.0266 34.3526 39.0647 34.463 39.0995C34.825 39.2124 35.1773 39.2689 35.5197 39.2689C35.9405 39.2689 36.2585 39.1718 36.4737 38.9777C36.689 38.78 36.7966 38.4976 36.7966 38.1306C36.7966 37.6435 36.4966 37.3064 35.8964 37.1193C35.854 37.1052 35.735 37.0681 35.5393 37.0081C35.3436 36.9446 35.1593 36.8846 34.9865 36.8281C34.8168 36.7681 34.6945 36.7222 34.6195 36.6905C33.6574 36.3234 33.1763 35.6386 33.1763 34.6362C33.1763 33.9338 33.4062 33.392 33.8661 33.0108C34.3292 32.6296 34.9424 32.439 35.7056 32.439C36.3804 32.439 36.9827 32.5562 37.5124 32.7908C37.7695 32.9046 37.8686 33.2064 37.7681 33.469C37.6456 33.7891 37.2763 33.9311 36.9527 33.8181C36.5334 33.6717 36.1357 33.5985 35.7594 33.5985C35.3648 33.5985 35.0664 33.6743 34.8641 33.8261C34.6652 33.9744 34.5592 34.2232 34.5461 34.5727C34.5461 35.0033 34.7435 35.2839 35.1381 35.4145C35.2164 35.4462 35.4088 35.5151 35.7154 35.621C36.022 35.7269 36.221 35.7957 36.3123 35.8274C36.9679 36.0604 37.4359 36.3498 37.7164 36.6957C38.0002 37.0417 38.142 37.5235 38.142 38.1411C38.142 38.8789 37.9007 39.4471 37.418 39.846C36.9352 40.2413 36.2846 40.439 35.4659 40.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1624,
    y: 30.9595,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1218,
    y: 30.9595,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#CA94FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5836 40.439C45.6065 40.439 44.8652 40.1823 44.3597 39.6691C43.8542 39.1523 43.6014 38.4255 43.6014 37.4888V33.1311C43.6014 32.7488 43.9113 32.439 44.2936 32.439C44.6758 32.439 44.9857 32.7488 44.9857 33.1311V37.3649C44.9857 38.0217 45.1112 38.5009 45.3623 38.8024C45.6167 39.1038 46.0323 39.2546 46.6091 39.2546C47.1757 39.2546 47.5862 39.1038 47.8406 38.8024C48.0951 38.4973 48.2223 38.0164 48.2223 37.3596V33.1285C48.2223 32.7477 48.531 32.439 48.9119 32.439C49.2927 32.439 49.6014 32.7477 49.6014 33.1285V37.4995C49.6014 38.4291 49.3436 39.1523 48.8279 39.6691C48.3122 40.1823 47.5641 40.439 46.5836 40.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1218,
    y: 30.9595,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1218,
    y: 41.9189,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#9D45F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.896 48.9348C44.896 49.4467 45.3109 49.8616 45.8228 49.8616C46.6221 49.8616 47.2304 49.6529 47.6476 49.2356C48.0648 48.8152 48.2734 48.2036 48.2734 47.4008C48.2734 46.5408 48.0584 45.9164 47.6285 45.5278C47.1986 45.136 46.5505 44.9401 45.6842 44.9401C45.2489 44.9401 44.896 45.293 44.896 45.7283V48.9348ZM45.6014 50.8984C44.4969 50.8984 43.6014 50.003 43.6014 48.8984V45.8984C43.6014 44.7939 44.4969 43.8984 45.6014 43.8984H45.6269C46.2384 43.8984 46.7862 43.9685 47.2702 44.1087C47.7543 44.2488 48.1699 44.4607 48.517 44.7442C48.8674 45.0245 49.1349 45.3876 49.3196 45.8336C49.5075 46.2764 49.6014 46.7892 49.6014 47.3722C49.6014 48.503 49.2607 49.3742 48.5791 49.9858C47.8976 50.5942 46.9534 50.8984 45.7463 50.8984H45.6014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1218,
    y: 41.9189,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1218,
    y: 52.8784,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#9D45F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5836 61.8579C45.6065 61.8579 44.8652 61.6334 44.3597 61.1843C43.8542 60.7321 43.6014 60.0961 43.6014 59.2765V55.55C43.6014 55.1678 43.9113 54.8579 44.2936 54.8579C44.6758 54.8579 44.9857 55.1678 44.9857 55.55V59.1681C44.9857 59.7428 45.1112 60.1621 45.3623 60.4259C45.6167 60.6897 46.0323 60.8216 46.6091 60.8216C47.1757 60.8216 47.5862 60.6897 47.8406 60.4259C48.0951 60.1589 48.2223 59.7381 48.2223 59.1634V55.5475C48.2223 55.1666 48.531 54.8579 48.9119 54.8579C49.2927 54.8579 49.6014 55.1666 49.6014 55.5475V59.2859C49.6014 60.0993 49.3436 60.7321 48.8279 61.1843C48.3122 61.6334 47.5641 61.8579 46.5836 61.8579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1218,
    y: 52.8784,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9594,
    y: 52.8784,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#CA94FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1306 61.8579C32.7487 61.8579 32.4391 61.5483 32.4391 61.1664V55.5494C32.4391 55.1675 32.7487 54.8579 33.1306 54.8579C33.5125 54.8579 33.8221 55.1675 33.8221 55.5494V55.7781C33.8221 56.5205 34.798 56.8843 35.2967 56.3344C35.8392 55.7389 36.222 55.3162 36.4452 55.0662C36.5627 54.9346 36.7304 54.8579 36.9069 54.8579C37.4303 54.8579 37.7072 55.4771 37.3582 55.8672L36.2096 57.1511C35.7664 57.6466 35.7408 58.3882 36.149 58.913L37.6385 60.8285C37.9644 61.2475 37.6658 61.8579 37.135 61.8579C36.9376 61.8579 36.7514 61.7666 36.6306 61.6105L34.6915 59.106C34.5263 58.8926 34.2189 58.8549 34.007 59.022C33.8903 59.1141 33.8221 59.2546 33.8221 59.4032V61.1664C33.8221 61.5483 33.5125 61.8579 33.1306 61.8579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9594,
    y: 52.8784,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.0812,
    y: 41.9189,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#B366FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9873 49.4874C56.3435 49.9793 56.8697 50.2252 57.5658 50.2252C58.2618 50.2252 58.7863 49.9811 59.1393 49.4927C59.4955 49.0007 59.6736 48.3071 59.6736 47.4117C59.6736 46.5057 59.4955 45.8032 59.1393 45.3042C58.7863 44.8052 58.2635 44.5557 57.5707 44.5557C56.8746 44.5557 56.3468 44.807 55.9873 45.3095C55.6311 45.8085 55.453 46.5093 55.453 47.4117C55.453 48.3035 55.6311 48.9954 55.9873 49.4874ZM57.5609 51.3984C56.4792 51.3984 55.6246 51.0445 54.9971 50.3367C54.3729 49.6254 54.0609 48.6451 54.0609 47.3958C54.0609 46.1394 54.3746 45.1591 55.002 44.4548C55.6295 43.7506 56.4841 43.3984 57.5658 43.3984C58.6475 43.3984 59.5004 43.7523 60.1246 44.4601C60.7488 45.1644 61.0609 46.1447 61.0609 47.4011C61.0609 48.6433 60.7471 49.6201 60.1197 50.3314C59.4922 51.0428 58.6393 51.3984 57.5609 51.3984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.0812,
    y: 41.9189,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9594,
    y: 41.9189,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#CF9FFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9594,
    y: 41.9189,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1218,
    y: 63.8374,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#CF9FFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1218,
    y: 63.8374,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1218,
    y: 20,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#CF9FFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1218,
    y: 20,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.0812,
    y: 52.8784,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#BF82FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.0812,
    y: 52.8784,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1624,
    y: 63.8374,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#BF82FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1624,
    y: 63.8374,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 30.9595,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#BF82FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 30.9595,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.0812,
    y: 20,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#BF82FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.0812,
    y: 20,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.0812,
    y: 30.9595,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#D9B9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.0812,
    y: 30.9595,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.0812,
    y: 63.8374,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#D9B9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.0812,
    y: 63.8374,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 52.8784,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#D9B9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 52.8784,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.0406,
    y: 41.9189,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    fill: "#D9B9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.0406,
    y: 41.9189,
    width: 10.9594,
    height: 10.9594,
    rx: 5.4797,
    stroke: "#682FA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_206_5868",
    x1: 47,
    y1: 0,
    x2: 47,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#511092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27202F",
    stopOpacity: 0.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_5868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSudokuGameImg);
export default __webpack_public_path__ + "static/media/SudokuGameImg.60e2ccc837fe0224d918d66f8f08e308.svg";
export { ForwardRef as ReactComponent };